import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useParams } from 'react-router-dom';
import { postIssue } from '../services/issueService';
import { IssueDto } from '../types/dto/issue';
import { withSimpleFormApiErrorHandling } from '../utils/simpleForm/handleSimpleFormApiError';

export const useIssue = () => {
    const { getAccessTokenSilently } = useAuth0();
    const { encryptedSimpleFormId } = useParams();
    const navigate = useNavigate();

    const createIssue = async (params: IssueDto): Promise<string> => {
        if (!encryptedSimpleFormId) {
            throw new Error(' no simple form hash detected');
        }

        return withSimpleFormApiErrorHandling(
            async () =>
                postIssue(await getAccessTokenSilently(), {
                    ...params,
                    encryptedSimpleFormId,
                }),
            navigate,
        );
    };

    return { createIssue };
};
